import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import im1 from "../assets/images/im28.webp";
const brands = [
  "Lenses....Zeiss",
  "Essilor",
  "Rodenstock",
  "Vision Rx",
  "Nova",
  "Kodak",
  "Vogue",
  "Tom Ford",
  "Ray-Ban",
  "Carrera",
  "Police",
  "Boss",
  "Mont Blanc",
];



export default function b1pages() {
  return (
    <>
      <Header />
      <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #d0eaff, white)",
        padding: "20px",
      }}
    >
      {/* Header Section */}
      <header style={{ textAlign: "center", marginBottom: "20px" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#000",
            marginBottom: "10px",
          }}
        >
          MYOPIA

        </h1>
        <p style={{ fontSize: "1rem", color: "gray" }}>
        Protect Your Vision &bull; Prioritize Your Eye Health
        </p>
      </header>

      {/* Image Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          maxWidth: "800px",
          width: "100%",
        }}
      >
        <img
          src={im1} // Replace with the actual image path
          alt="Affordable eyewear online"
          style={{ width: "100%", height: "auto", borderRadius: "10px" }}
        />
      </div>

     
    </div>
    <div
      style={{
        maxWidth: "800px",
        margin: "40px auto",
        padding: "0 20px",
        fontFamily: "'Georgia', serif",
        lineHeight: "1.8",
        color: "#333",
      }}
    >
      {/* Title Section */}
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Understanding Myopia
      </h1>

      {/* Content Section */}
      <p style={{ marginBottom: "20px" }}>
      Myopia, commonly known as shortsightedness, is a condition where parallel rays of light are focused in front of the retina instead of
       directly on it, leading to difficulty seeing distant objects clearly. It is classified into various types such as Axial Myopia 
       (due to an increase in the eyeball's anteroposterior length), Curvatural Myopia (caused by an increased curvature of the cornea or lens),
        and Positional Myopia (due to anterior placement of the crystalline lens). Myopia can also result from excessive accommodation in cases of accommodation spasms.
      </p>
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Types
      </h1>
      <p style={{ marginBottom: "20px" }}>
      Based on severity, myopia is graded as low (-3D or less), moderate (-3D to -6D), or high (-6D or more). Clinically,
       it may present as congenital, simple or developmental, pathological, or acquired myopia. Congenital myopia, often unilateral, 
       is present at birth and diagnosed in early childhood. Simple myopia, the most common type, often emerges during school years 
       (8-12 years) due to biological variations and environmental factors like prolonged near work or limited outdoor activities.
        Pathological myopia involves progressive degeneration of the retina and choroid,leading to severe visual impairment and complications 
        like retinal detachment and cataracts.
      </p>
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Symptoms
      </h1>
      <p style={{ marginBottom: "20px" }}>
      Symptoms of myopia include poor distance vision, eye strain, and a tendency to squint. Advanced cases may exhibit floaters, 
      difficulty with night vision, and degenerative changes in the retina and vitreous. Diagnosis involves thorough clinical evaluation,
       including history, ocular examinations, and tests for refractive errors and binocular vision.
      </p>
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        Treatment Options
      </h1>
      <p style={{ marginBottom: "20px" }}>
        Treatment options for myopia include optical aids like spectacles and contact lenses, which correct refractive errors. 
        In high myopia, contact lenses are preferred to minimize image distortion. Surgical interventions, such as refractive surgeries,
         and preventive measures, including atropine drops, balanced diets, proper visual hygiene, and increased outdoor activities, 
         can help manage and mitigate progression. In advanced cases, low vision aids are recommended to improve visual functionality.
      </p>
    </div>
      <Footer />
    </>
  );
}